/* global location */
/* eslint no-restricted-globals: ["off", "location"] */
const Util = {
  getPvid: () => {
    if (window.dmtrack_pageid) {
      return window.dmtrack_pageid;
    } else if (window.aplus && window.aplus.pvid) {
      return window.aplus.pvid;
    } else {
      return '';
    }
  },
  getUrlParam: (name) => {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`); //构造一个含有目标参数的正则表达式对象
    const r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) {
      let rt;
      try {
        rt = decodeURIComponent(r[2]);
      } catch (e) {
        rt = r[2];
      }
      return rt;
    }
    return null; //返回参数值
  },
  getUrlParms: () => {
    const args = new Object();
    const query = location.search.substring(1);//获取查询串
    const pairs = query.split("&");//在逗号处断开
    for (let i = 0; i < pairs.length; i++) {
      const pos = pairs[i].indexOf('=');//查找name=value
      if (pos == -1) continue;//如果没有找到就跳过
      const argname = pairs[i].substring(0, pos);//提取name
      const value = pairs[i].substring(pos + 1);//提取value
      if (argname == "keywords") {
        args[argname] = pageConfig.keywords;
        continue;
      }
      try {
        args[argname] = decodeURIComponent(value);//存为属性
      } catch (e) {
        args[argname] = value;//存为属性
      }
    }
    return args;
  },
  getHashParam: (hash) => {
    const args = new Object();
    const pairs = hash.split("&");//在逗号处断开
    for (let i = 0; i < pairs.length; i++) {
      const pos = pairs[i].indexOf('=');//查找name=value
      if (pos == -1) continue;//如果没有找到就跳过
      const argname = pairs[i].substring(0, pos);//提取name
      const value = pairs[i].substring(pos + 1);//提取value

      try {
        args[argname] = decodeURIComponent(value);//存为属性
      } catch (e) {
        args[argname] = value;//存为属性
      }
    }
    return args;
  },
  htmlEncode: (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return JSON.parse(div.innerText);
  },
  getLocationOrigin: () => {
    //兼容ie浏览器
    if (window.context == undefined) {
      if (!window.location.origin) {
        window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
      }
      window.context = `${location.origin}/V6.0`;
    }
    return window.location.origin;
  },
  getCookie: (sKey) => {
    return (
      decodeURIComponent(
        document.cookie.replace(
          new RegExp(
            '(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'
          ),
          '$1'
        )
      ) || null
    );
  },
  formatNumber: (val, decimals) => {
    const num = val - 0;
    let strNum = val;
    if (num && num >= 100000000) {
      strNum = (num / 100000000).toFixed(1) + "亿";
    } else if (num && num >= 10000) {
      strNum = (num / 10000).toFixed(1) + "万";
    } else {
      strNum = !num ? val + "" : num.toFixed(decimals);
    }
    return strNum.split(".");
  },
  objToUrlParams: (obj) => {
    return new URLSearchParams(obj).toString();
  },
}
export default Util;
